module.exports = "/lucky-balls/img/regular_game/header_betin.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_betin.png
// module id = 1142
// module chunks = 0